module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (258).69eeaa74.jpg";